import { render } from "./PublicWaitingRoomOverlay.vue?vue&type=template&id=02491570&scoped=true&ts=true"
import script from "./PublicWaitingRoomOverlay.vue?vue&type=script&lang=ts"
export * from "./PublicWaitingRoomOverlay.vue?vue&type=script&lang=ts"

import "./PublicWaitingRoomOverlay.vue?vue&type=style&index=0&id=02491570&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02491570"]])

export default __exports__